<template>
  <v-app>
    <v-main>
      <section class="login overflow-hidden">
        <v-row align="center" justify="center" style="height: 100vh" dense>
          <v-col
            class="right-part align-content-space-between layout wrap"
            cols="12"
            md="8"
            :pa-5="$vuetify.breakpoint.smAndDown"
            align-self="center"
          >

            <v-row align="center" justify="center">
              <v-col cols="12" md="5" style="color: grey">

                <logo-1 />
                <div class="fancy-text text-center pb-5">{{ $t("welcome.title") }}</div>

                <v-form v-model="valid" ref="form" lazy-validation>
                  <v-card class="login mb-2 elevation-0">
                    <v-container grid-list-sm class="pa-4">
                      <v-layout row wrap>
                        <v-flex xs12>
                          <v-text-field
                            color="black"
                            prepend-icon="person"
                            :label="$t('login.email')"
                            v-model="email"
                            :rules="emailRules"
                            required
                            single-line
                            dense
                          ></v-text-field>
                        </v-flex>

                        <v-flex xs12>
                          <v-text-field
                            :append-icon="
                              show_pw ? 'visibility' : 'visibility_off'
                            "
                            color="black"
                            :type="show_pw ? 'text' : 'password'"
                            prepend-icon="lock"
                            :label="$t('login.password')"
                            v-model="password"
                            :rules="passwordRules"
                            @click:append="show_pw = !show_pw"
                            required
                            single-line
                            dense
                          >
                          </v-text-field>
                        </v-flex>
                      </v-layout>
                    </v-container>
                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn text @click="clear">{{
                        $t("login.btn-cancel")
                      }}</v-btn>
                      <v-btn text @click="auth" :disabled="!valid">{{
                        $t("login.btn-submit")
                      }}</v-btn>
                    </v-card-actions>
                  </v-card>
                </v-form>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </section>
    </v-main>
    <v-footer app></v-footer>
  </v-app>
</template>


<script>
import Auth from "@/core/auth";
export default {
  components: {
    logo1: () => import("@/components/common/logo1"),
  },
  data: () => ({
    valid: true,
    email: "",
    password: "",
    show_pw: false,
    emailRules2: [
      (v) => !!v || "E-mail is required",
      (v) =>
        /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+\s*$/.test(v) ||
        "E-mail must be valid",
    ],
    passwordRules2: [(v) => !!v || "Password is required"],
    checkbox: false,
  }),
  methods: {
    clear() {
      this.$refs.form.reset();
    },
    auth() {
      var app = this;
      console.log("auth ");
      if (!this.isOnline) {
        this.$bus.$emit("isOnline", this.isOnline);
        //return
      }
      if (this.$refs.form.validate()) {
        console.log("auth ");
        Auth.login(
          app,
          {
            email: this.email.trim(),
            password: this.password,
          },
          (result) => {
            if (result.err) {
              this.errMsg = result;
              app.$bus.$emit("notification", this.errMsg);
            }
          }
        );
      }
    },
    prefill() {
      this.email = this.user.email || "";
    },
  },
  computed: {
    emailRules() {
      return [
        (v) => !!v || this.$t("login.message.email"),
        (v) =>
          /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+\s*$/.test(v) ||
          this.$t("login.message.emailNotValid"),
      ];
    },
    passwordRules() {
      return [(v) => !!v || this.$t("login.message.password")];
    },
    user: {
      cache: false,
      get() {
        return this.$store.getters.user;
      },
    },
    isOnline: {
      cache: false,
      get() {
        return this.$store.getters.get_online;
      },
    },
  },
  created() {
    this.prefill();
  },
};
</script>

<style lang="scss">
.v-application .login {
  .fancy-text {
    font-style: italic;
    font-size: 28px;
    font-weight: 200;
    line-height: 1.5;
    font-family: "Roboto", sans-serif;
  }
  //.v-input--dense .v-input__icon--append .v-input__icon>.v-icon {
  .v-input--dense .v-input__append-inner .v-icon.v-icon {
    margin-top: 0 !important;
    font-size: 16px !important;
  }
}
</style>
